import { render, staticRenderFns } from "./bodyRequiredMajor.vue?vue&type=template&id=82ad56ec&scoped=true&"
import script from "./bodyRequiredMajor.vue?vue&type=script&lang=js&"
export * from "./bodyRequiredMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ad56ec",
  null
  
)

export default component.exports